import { IdentityProvider } from "../../../../domain/IdentityProvider";
import { Dropdown } from "@optimizely/axiom";

type IdentityProviderDropdownProps = {
    disabled?: boolean;
    identityProviders: IdentityProvider[];
    onChange: ({ identityProvider }: { identityProvider: IdentityProvider }) => void;
};

export const IdentityProviderDropdown = ({
    disabled = false,
    identityProviders,
    onChange
}: IdentityProviderDropdownProps) => {
    return (
        <Dropdown
            buttonContent={"Add SCIM to an SSO Connection"}
            width={600}
            arrowIcon="down"
            isDisabled={disabled || !identityProviders.length}
        >
            <Dropdown.Contents>
                {identityProviders.map((idp, idx) => {
                    return (
                        <Dropdown.ListItem key={idp.id}>
                            <Dropdown.BlockLink
                                onClick={() => {
                                    onChange({ identityProvider: idp });
                                }}
                            >
                                {idp.idpName}
                            </Dropdown.BlockLink>
                        </Dropdown.ListItem>
                    );
                })}
            </Dropdown.Contents>
        </Dropdown>
    );
};

IdentityProviderDropdown.displayName = "IdentityProviderDropdown";
